/* Craftly: Auto-add bracelet gift when couple kit is in cart (Tu B'Av 2026) */
(function(){
  if (window.__cdkGiftWatch) return;
  window.__cdkGiftWatch = true;

  var COUPLE_KIT_PRODUCT_ID = 7745447886947;
  var GIFT_VARIANT_ID       = 44298117939299;
  var GIFT_PRODUCT_ID       = 8048019538019;
  var GIFT_LABEL            = 'מתנת טו באב';
  var CART_SECTION          = 'mini-cart';
  var CART_SECTION_ID       = 'shopify-section-mini-cart';
  var lastSync = 0;
  var syncing  = false;

  function getCart(){
    return fetch('/cart.js', { credentials:'same-origin', cache:'no-store' })
      .then(function(r){ return r.json(); });
  }

  // Inject GIFT styling/locking into any row in the given root
  function styleGiftLineIn(root){
    if (!root) return;
    var sel = '[data-cart-item], .cart-item, .cart__row, [data-line-item], .cart-drawer__item, ' +
              '[data-line-id], cart-drawer-items > * , .drawer__contents li, ' +
              '.cart-items__row, .mini-cart__item, [data-key]';
    root.querySelectorAll(sel).forEach(function(row){
      var txt  = (row.textContent || '');
      var html = (row.innerHTML || '');
      var isGift = (
        html.indexOf('BRACELET-GIFT') >= 0 ||
        txt.indexOf('מתנת טו באב') >= 0 ||
        txt.indexOf('סט צמידי אהבה זוגיים - מתנת') >= 0 ||
        (row.dataset && row.dataset.variantId === String(GIFT_VARIANT_ID))
      );
      if (isGift && !row.classList.contains('cdk-gift-line')){
        row.classList.add('cdk-gift-line');
        row.querySelectorAll('input[name="updates[]"], input[type="number"], button[name="minus"], button[name="plus"], .quantity__button, [data-action="add-to-cart"], [data-action="remove"], [data-cart-remove], [data-line-quantity-change]').forEach(function(el){
          el.disabled = true;
          el.setAttribute('tabindex','-1');
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.30';
        });
        row.querySelectorAll('a[href*="/cart/change"], cart-remove-button, .cart-remove-button, .cart-item__remove').forEach(function(el){
          el.style.display = 'none';
        });
        if (!row.querySelector('.cdk-gift-badge')){
          var badge = document.createElement('div');
          badge.className = 'cdk-gift-badge';
          badge.innerHTML = '🎁 מתנה - חינם בקיט הזוגי';
          row.insertBefore(badge, row.firstChild);
        }
      }
    });
  }
  // Backward compat alias for outside callers
  function styleGiftLine(){ styleGiftLineIn(document); }

  function replaceCartSection(sectionsObj){
    if (!sectionsObj || !sectionsObj[CART_SECTION]) return;
    var current = document.getElementById(CART_SECTION_ID);
    if (!current) return;

    // Detect open state BEFORE replacing
    var oldDrawer = current.querySelector('cart-drawer, .drawer, [data-cart-drawer], #mini-cart');
    var bodyOpen = document.body.classList.contains('drawer-open') ||
                   document.body.classList.contains('cart-drawer-open');
    var wasOpen = !!oldDrawer && (
      oldDrawer.hasAttribute('open') ||
      oldDrawer.getAttribute('aria-hidden') === 'false' ||
      oldDrawer.classList.contains('is-open') ||
      oldDrawer.classList.contains('is-active') ||
      oldDrawer.classList.contains('drawer--open') ||
      oldDrawer.classList.contains('open') ||
      bodyOpen
    );

    // Parse new HTML in a detached container so we can pre-style + pre-open BEFORE DOM insertion
    // (this eliminates the visual morph/flash when the gift line is unstyled momentarily)
    var tmp = document.createElement('div');
    tmp.innerHTML = sectionsObj[CART_SECTION];

    // Pre-set open state on the new drawer so no slide-in transition fires
    if (wasOpen){
      var newDrawer = tmp.querySelector('cart-drawer, .drawer, [data-cart-drawer], #mini-cart');
      if (newDrawer){
        newDrawer.setAttribute('open','');
        newDrawer.setAttribute('aria-hidden','false');
        newDrawer.classList.add('is-open','is-active','drawer--open','open');
      }
    }

    // Pre-apply gift styling/locking so the row appears already styled
    styleGiftLineIn(tmp);

    // Disable transitions on the section for one frame to prevent any flicker
    current.style.transition = 'none';

    // Single, atomic DOM swap
    current.innerHTML = tmp.innerHTML;

    // Restore body classes if needed (do this synchronously)
    if (wasOpen && bodyOpen){
      document.body.classList.add('drawer-open','cart-drawer-open');
    }

    // Re-enable transitions on next frame + bubble standard refresh events
    requestAnimationFrame(function(){
      current.style.transition = '';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  function addGift(){
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({
        items:[{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties:{ '_gift': GIFT_LABEL, '_locked':'1' }
        }],
        sections: CART_SECTION
      })
    }).then(function(r){ return r.json(); }).then(function(data){
      replaceCartSection(data.sections);
    });
  }

  // For REMOVE: SURGICAL DOM removal — no section replacement (avoids drawer re-render)
  function removeGiftSurgical(key){
    return fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(){
      // Animate-out then remove the gift row
      document.querySelectorAll('.cdk-gift-line').forEach(function(row){
        row.style.transition = 'opacity .2s ease, transform .2s ease';
        row.style.opacity = '0';
        row.style.transform = 'translateX(-12px)';
        setTimeout(function(){ try { row.remove(); } catch(e){} }, 200);
      });
      // Let the theme update totals (cart count, subtotal) via standard event
      setTimeout(function(){
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      }, 220);
    });
  }

  function changeQtySurgical(key, qty){
    return fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    }); // no UI re-render - the qty correction is silent
  }

  function syncGiftWithCart(){
    var now = Date.now();
    if (syncing || now - lastSync < 600) return;
    lastSync = now;
    syncing = true;

    getCart().then(function(cart){
      var items   = cart.items || [];
      var hasKit  = items.some(function(it){ return it.product_id === COUPLE_KIT_PRODUCT_ID; });
      var giftIt  = items.filter(function(it){ return it.variant_id === GIFT_VARIANT_ID; })[0];
      var hasGift = !!giftIt;

      if (hasKit && !hasGift)         return addGift();
      if (!hasKit && hasGift)         return removeGiftSurgical(giftIt.key);
      if (hasKit && hasGift && giftIt.quantity !== 1) return changeQtySurgical(giftIt.key, 1);
    }).catch(function(){}).then(function(){ syncing = false; });
  }

  // Single event listener (consolidated) - debounced
  var syncTimer = null;
  function queueSync(){
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function(){ syncTimer = null; syncGiftWithCart(); }, 320);
  }

  ['cart:refresh','cart:item-added','cart:item-removed','cart:updated','cart:build',
   'on:cart:added','on:cart:updated','product:added'].forEach(function(n){
    document.addEventListener(n, queueSync);
  });

  // Intercept fetches to /cart/*  but ignore our OWN add/change calls (avoid feedback loops)
  var origFetch = window.fetch;
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (url && (/\/cart\/(add|change|update|clear)/i).test(url)) {
      // Don't re-trigger sync if WE made the call (body contains our variant id)
      var body = init && init.body;
      var ours = false;
      if (typeof body === 'string') {
        ours = body.indexOf(String(GIFT_VARIANT_ID)) >= 0;
      }
      if (!ours) p.then(queueSync).catch(function(){});
    }
    return p;
  };

  // Initial sync
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(syncGiftWithCart, 700); });
  } else {
    setTimeout(syncGiftWithCart, 700);
  }

  // Inject scoped CSS once - includes the gift styling
  if (!document.getElementById('cdk-gift-style')){
    var st = document.createElement('style');
    st.id = 'cdk-gift-style';
    st.textContent = ''
      + '.cdk-gift-line{position:relative !important;background:linear-gradient(135deg,rgba(214,51,108,.08) 0%,rgba(255,107,157,.04) 100%) !important;border:1.5px solid rgba(214,51,108,.30) !important;border-radius:12px !important;padding:12px !important;margin:8px 0 !important;box-shadow:0 2px 8px rgba(214,51,108,.12) !important;contain:layout style}'
      + '.cdk-gift-line .cdk-gift-badge{display:inline-flex !important;align-items:center !important;gap:5px !important;background:linear-gradient(135deg,#FF6B9D,#D6336C) !important;color:#fff !important;font-size:10px !important;font-weight:900 !important;padding:4px 10px !important;border-radius:6px !important;letter-spacing:.3px !important;margin-bottom:8px !important;box-shadow:0 2px 6px rgba(214,51,108,.4) !important;width:fit-content}'
      + '.cdk-gift-line .price,.cdk-gift-line .cart-item__price,.cdk-gift-line .product-price{color:#1F6F4A !important;font-weight:900 !important}'
      + '.cdk-gift-line .compare-at-price,.cdk-gift-line s,.cdk-gift-line del,.cdk-gift-line .price--on-sale .price__regular,.cdk-gift-line .cart-item__price--strike{color:#9A9089 !important;text-decoration:line-through !important;text-decoration-color:#D6336C !important;text-decoration-thickness:2px !important}';
    document.head.appendChild(st);
  }

  // Re-style any gift lines that appear via theme's own re-renders (defensive)
  // Throttled to once per 300ms to avoid jitter
  var styleThrottle = null;
  function throttleStyle(){
    if (styleThrottle) return;
    styleThrottle = setTimeout(function(){ styleThrottle = null; styleGiftLine(); }, 300);
  }
  ['cart:refresh','cart:build','cart:updated','cart:item-added','cart:item-removed'].forEach(function(n){
    document.addEventListener(n, throttleStyle);
  });
  setTimeout(styleGiftLine, 900);
})();
